export default __webpack_public_path__ + "static/4-cf4b4a620358ca803f882dbc7deba09c.png";